// import { useCookies } from 'vue3-cookies'
//
// const { cookies } = useCookies()
//
// function get_domain () {
//   if (import.meta.env.VITE_VUE_APP_COOKIE_DOMAIN !== undefined) {
//     return import.meta.env.VITE_VUE_APP_COOKIE_DOMAIN
//   } else {
//     return null
//   }
// }

export class SocketV2 {
  socket = null
  url = null
  handlers
  onClose
  onMessage
  onError
  onOpen

  constructor ({
    url,
    handlers,
    onOpen = () => {
    },
    onClose = () => {
    },
    onMessage = () => {
    },
    onError = () => {
    }
  }) {
    this.url = url
    this.handlers = handlers
    this.onOpen = onOpen
    this.onClose = onClose
    this.onMessage = onMessage
    this.onError = onError
  }

  setOnOpen (cb = null) {
    /**
     * Устанавливает обработчик открытия соединения
     * @param {function} cb - фунция обратного вызова при открытии соединения
     */
    this.socket.onopen = () => {
      if (cb) {
        cb(this.socket)
      } else {
        this.onOpen(this.socket)
      }
    }
  }

  setOnMessage (cb = null) {
    /**
     * Устанавливает обработчик получения сообщений
     * @param {Function} cb - функция обратного вызова при получении сообщения
     */
    this.socket.onmessage = (event) => {
      try {
        const message = JSON.parse(event.data)
        if (this.handlers[message.type]) {
          this.handlers[message.type]({
            data: message,
          })
        }
        if (cb) {
          cb(this.socket, message)
        } else {
          this.onMessage(this.socket, message)
        }
      } catch (e) {
        console.error('Error parsing message:', e)
      }
    }
  }

  setOnError (cb = null) {
    /**
     * Устанавливает обработчик ошибок соединения
     * @param {Function} cb - функция обратного вызова при ошибке соединения
     */
    this.socket.onerror = (error) => {
      console.error('WebSocket error:', error)
      if (error instanceof Event && error.target instanceof WebSocket) {
        console.error('WebSocket error details:', error.target.readyState, error.target.url)
        this.socket = null
      }
      if (cb) {
        cb(this.socket, error)
      } else {
        this.onError(this.socket, error)
      }
    }
  }

  setOnClose (cb = (socket, error) => {
  }) {
    /**
     * Устанавливает обработчик закрытия соединения
     * @param {Function} cb - функция обратного вызова при закрытии соединения
     */
    this.socket.onclose = (event) => {
      if (cb) {
        cb(this.socket, event)
      } else {
        this.onClose(this.socket, event)
      }
      // window.location.reload()
    }
  }

  isConnected () {
    /**
     * Проверяет состояние подключения
     * @returns {boolean} true, если соединение установлено, иначе false
     */
    return this.socket !== null && this.socket !== undefined
  }

  connect ({
    url = null,
  }) {
    /**
     * Устанавливает соединение с WebSocket сервером
     * @param {Object} options - параметры соединения
     * @param {string} options.url - URL для подключения (если не указан, используется сохраненный)
     * @returns {Promise} промис, разрешаемый при успешном соединении
     */
    return new Promise((resolve, reject) => {
      if (url) {
        this.url = url
      }
      this.socket = new WebSocket(this.url)
      this.setOnOpen((socket) => {
        resolve(socket)
        this.onOpen()
      })
      this.setOnClose(this.onClose)
      this.setOnMessage(this.onMessage)
      // eslint-disable-next-line n/handle-callback-err
      this.setOnError((err) => {
        reject(reject)
        this.onError()
      })
    })
  }

  disconnect (onclose = () => {
  }) {
    /**
     * Отключает соединение
     * @param {Function} onclose - функция обратного вызова при отключении
     */
    if (this.socket) {
      this.setOnClose(onclose)
      this.socket.close()
    }
  }

  disconnectWithClearSocket (onclose = () => {
  }) {
    /**
     * Отключает соединение с очисткой ссылки на сокет
     * @param {Function} onclose - функция обратного вызова при отключении
     */
    if (this.socket) {
      this.setOnClose(onclose)
      this.socket.close()
      this.socket = null
    }
  }

  addHandler (handlerName, handler) {
    /**
     * Добавляет обработчик сообщений
     * @param {string} handlerName - имя типа сообщения
     * @param {Function} handler - функция-обработчик
     */
    this.handlers[handlerName] = handler
  }

  addHandlers (handlers) {
    /**
     * Добавляет несколько обработчиков сообщений
     * @param {Object} handlers - объект с обработчиками (ключ - тип сообщения, значение - функция)
     */
    this.handlers = { ...this.handlers, ...handlers }
  }

  replaceHandlers (handlers) {
    /**
     * Заменяет все обработчики сообщений
     * @param {Object} handlers - новый объект с обработчиками
     */
    this.handlers = handlers
  }

  sendMessage (message) {
    /**
     * Отправляет сообщение на сервер
     * @param {Object} message - объект сообщения для отправки
     */
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      this.socket.send(JSON.stringify(message))
    } else {
      console.error('WebSocket is not open. Message not sent:', message)
    }
  }

  showNotification ({
    title,
    text,
    type
  }) {
    /**
     * Показывает уведомление через кастомное событие
     * @param {Object} options - параметры уведомления
     * @param {string} options.title - заголовок уведомления
     * @param {string} options.text - текст уведомления
     * @param {string} options.type - тип уведомления
     */
    window.dispatchEvent(new CustomEvent('show-notification', {
      detail: {
        title,
        text,
        type
      }
    }))
  }
}

export const MESSAGES_TYPES = {
  AUTH: 'auth',
  NEW_EVENT: 'new_event',
  OLD_MESSAGES: 'old_messages',
  HEARTBEAT: 'heartbeat',
  RECEIVE_MESSAGE: 'receive_message',
  RECEIVE_ALL_MESSAGE: 'receive_all_message',
  REACTION_MESSAGE: 'reaction_message',
  ACCEPT: 'accept',
  ERROR: 'error',
}
